import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ServiceFAQ = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const faqData = [
    {
      id: 1,
      question: 'ฉันสามารถยื่นเรื่องร้องเรียนผ่านออนไลน์ได้หรือไม่?',
      answer: `ได้ครับ/ค่ะ ท่านสามารถยื่นเรื่องร้องเรียนผ่านระบบออนไลน์ได้ตลอด 24 ชั่วโมง\nเพียงกรอกแบบฟอร์มให้ครบถ้วนและรอการติดต่อกลับจากเจ้าหน้าที่\nภายใน 3-5 วันทำการ`
    },
    {
      id: 2,
      question: 'ระยะเวลาในการดำเนินการเรื่องร้องเรียนใช้เวลานานแค่ไหน?',
      answer: `การดำเนินการขึ้นอยู่กับประเภทและความซับซ้อนของเรื่องร้องเรียน:\n• เรื่องทั่วไป: 7-15 วันทำการ\n• เรื่องซับซ้อน: 15-30 วันทำการ\n• เรื่องเร่งด่วน: 3-7 วันทำการ`
    },
    {
      id: 3,
      question: 'ฉันจะติดตามสถานะเรื่องร้องเรียนได้อย่างไร?',
      answer: `ท่านสามารถติดตามสถานะได้หลายช่องทาง:\n• โทรศัพท์: 02-123-4567\n• อีเมล: districtthoeng@gmail.com\n• มาติดตามด้วยตนเองที่สำนักงาน\nโดยแจ้งหมายเลขอ้างอิงที่ได้รับหลังยื่นเรื่อง`
    },
    {
      id: 4,
      question: 'เอกสารใดบ้างที่ต้องแนบมาด้วยเมื่อยื่นเรื่องร้องเรียน?',
      answer: `เอกสารที่แนะนำให้แนบ:\n• สำเนาบัตรประชาชน\n• หลักฐานที่เกี่ยวข้อง (ภาพถ่าย, เอกสาร)\n• แผนที่หรือที่อยู่ที่เกิดเหตุ (ถ้ามี)\nหมายเหตุ: เอกสารเหล่านี้จะช่วยให้การดำเนินการรวดเร็วขึ้น`
    },
    {
      id: 5,
      question: 'หากไม่พอใจผลการดำเนินการ ฉันสามารถอุทธรณ์ได้หรือไม่?',
      answer: `ได้ครับ/ค่ะ ท่านมีสิทธิ์อุทธรณ์ภายใน 30 วัน นับจากวันที่ได้รับผลการดำเนินการ\nโดยยื่นหนังสืออุทธรณ์พร้อมเหตุผลมายังอำเภอเทิง\nหรือยื่นต่อหน่วยงานที่กำกับดูแลในระดับที่สูงขึ้น`
    }
  ];

  const toggleFAQ = (faqId) => {
    setExpandedFAQ(expandedFAQ === faqId ? null : faqId);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-government">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="HelpCircle" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">
          คำถามที่พบบ่อย
        </h3>
      </div>
      <div className="space-y-4">
        {faqData?.map((faq) => (
          <div key={faq?.id} className="border border-border rounded-lg">
            <button
              onClick={() => toggleFAQ(faq?.id)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-muted/50 transition-government rounded-lg"
              aria-expanded={expandedFAQ === faq?.id}
            >
              <span className="font-medium text-foreground pr-4">
                {faq?.question}
              </span>
              <Icon 
                name={expandedFAQ === faq?.id ? 'ChevronUp' : 'ChevronDown'} 
                size={20} 
                className="text-muted-foreground flex-shrink-0 transition-government"
              />
            </button>
            
            {expandedFAQ === faq?.id && (
              <div className="px-4 pb-4 border-t border-border">
                <div className="pt-4 text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
                  {faq?.answer}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="text-accent flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-medium text-accent-foreground mb-1">
              ต้องการความช่วยเหลือเพิ่มเติม?
            </h4>
            <p className="text-sm text-muted-foreground">
              หากไม่พบคำตอบที่ต้องการ กรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางที่ระบุไว้ข้างต้น
              หรือมาติดต่อด้วยตนเองในเวลาทำการ
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceFAQ;